import React, { Fragment, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { Navigate } from "react-router-dom";

import { SET_LOGED, SET_UNAME } from '../../redux/reducers/site';

var msg = null;

export default function LogOut(){
    const dispatch = useDispatch()
    const setup = useSelector(state => state.site.setup);

    // Явно проверяем, что язык валиден, иначе используем 'ru' по умолчанию
    let LANG = ['ru', 'en', 'de'].includes(setup.lang) ? setup.lang : 'ru';

    localStorage.clear();
    dispatch(SET_LOGED(false));
    dispatch(SET_UNAME(null));

return(
<Fragment>
<Navigate to={'/'+LANG}/>
</Fragment>
 )


}